<template>
  <div class="main-logo">
    <NuxtLink v-if="link" :to="link">
      <component :is="componentIconsLogo" />
    </NuxtLink>
    <component :is="componentIconsLogo" v-else />
  </div>
</template>

<script setup lang="ts">
import {useUniWebTemplate} from "~/composables/useUniWebTemplate"
import {TemplateList} from "~/libs/constants/TemplateList"

const {
  link
} = defineProps({
  link: {type: String, required: false, default: "/"}
})

const template = useUniWebTemplate()
let componentIconsLogo: any
switch (template.uniWebTemplateNameLowerCase) {
  case TemplateList.MATERIDOUSKA:
    componentIconsLogo = resolveComponent('MateridouskaIconsLogo')
    break
  case TemplateList.POGGERS:
    componentIconsLogo = resolveComponent('PoggersIconsLogo')
    break
  default:
    componentIconsLogo = resolveComponent('DefaultIconsLogo')
}
</script>

